<template>
    <v-card>
        <v-card-title class="text-h5 mb-3">
            <strong>Ganancias resultados</strong>
            <v-spacer/>
            <v-btn
                class="text-capitalize mb-2 mb-sm-0 mr-2"
                :href="`/admin/export-profits-results?dateInit=${dateInit}&dateEnd=${dateEnd}&filterTime=${filterTime}&filterAnalysis=${filterAnalysis}`"
            >
                <v-icon class="mr-2" color="green">mdi-file-excel</v-icon>
                Exportar
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="6">
                    <v-select
                        label="Tiempo"
                        outlined
                        dense
                        :items="itemsTimes"
                        item-text="name"
                        item-value="val"
                        v-model="filterTime"
                        @change="getData"
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-select
                        label="Analizar"
                        outlined
                        dense
                        :items="itemsAnalysis"
                        item-text="name"
                        item-value="val"
                        v-model="filterAnalysis"
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="6" v-if="filterTime=='custom'">
                    <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dateInit"
                                label="Fecha inicial"
                                prepend-icon="mdi-calendar"
                                readonly
                                outlined
                                dense
                                color="orange"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dateInit"
                            @input="menu1 = false, getData()"
                            locale="es"
                            color="primary"
                            class="ma-0"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="6" v-if="filterTime=='custom'">
                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dateEnd"
                                label="Fecha final"
                                prepend-icon="mdi-calendar"
                                readonly
                                outlined
                                dense
                                color="orange"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dateEnd"
                            @input="menu2 = false, getData()"
                            locale="es"
                            color="primary"
                            class="ma-0"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>

            <v-divider/>

            <v-simple-table v-if="!loading">
                <template v-slot:default>
                <tbody>
                    <tr>
                        <td class="grey lighten-3"><strong>VENTAS</strong></td>
                        <td class="grey lighten-3" v-if="filterAnalysis=='both'"><strong>{{ roundToTwo(dataResult['sales-physical']+dataResult['sales-virtual']) }}</strong></td>
                        <td class="grey lighten-3" v-if="filterAnalysis=='physical'"><strong>{{ roundToTwo(dataResult['sales-physical']) }}</strong></td>
                        <td class="grey lighten-3" v-if="filterAnalysis=='virtual'"><strong>{{ roundToTwo(dataResult['sales-virtual']) }}</strong></td>
                    </tr>
                    <tr v-if="filterAnalysis=='physical' || filterAnalysis=='both'">
                        <td>Ventas físicas</td>
                        <td>{{ roundToTwo(dataResult['sales-physical']) }}</td>
                    </tr>
                    <tr v-if="filterAnalysis=='virtual' || filterAnalysis=='both'">
                        <td>Ventas digitales</td>
                        <td>{{ roundToTwo(dataResult['sales-virtual']) }}</td>
                    </tr>
                    <tr>
                        <td class="grey lighten-3"><strong>COSTOS DE VENTAS</strong></td>
                        <td class="grey lighten-3" v-if="filterAnalysis=='both'"><strong>-{{ roundToTwo(dataResult['costs-physical']+dataResult['costs-virtual']) }}</strong></td>
                        <td class="grey lighten-3" v-if="filterAnalysis=='physical'"><strong>-{{ roundToTwo(dataResult['costs-physical']) }}</strong></td>
                        <td class="grey lighten-3" v-if="filterAnalysis=='virtual'"><strong>-{{ roundToTwo(dataResult['costs-virtual']) }}</strong></td>
                    </tr>
                    <tr v-if="filterAnalysis=='physical' || filterAnalysis=='both'">
                        <td>Ventas físicas</td>
                        <td>-{{ roundToTwo(dataResult['costs-physical']) }}</td>
                    </tr>
                    <tr v-if="filterAnalysis=='virtual' || filterAnalysis=='both'">
                        <td>Ventas digitales</td>
                        <td>-{{ roundToTwo(dataResult['costs-virtual']) }}</td>
                    </tr>
                    <tr>
                        <td class="grey lighten-3"><strong>GASTOS FIJOS</strong></td>
                        <td class="grey lighten-3"><strong>-{{ roundToTwo(dataResult['total-expenses']) }}</strong></td>
                    </tr>
                    <tr v-for="(exp, i) in dataResult.expenses" :key="i">
                        <td class="text-capitalize">-{{ i }}</td>
                        <td>-{{ roundToTwo(exp.map(item => item.value).reduce((a, b) => a + b, 0)) }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td class="grey lighten-2"><strong>GANANCIAS</strong></td>
                        <td class="grey lighten-2" v-if="filterAnalysis=='both'"><strong>{{ roundToTwo((dataResult['sales-physical']+dataResult['sales-virtual']) + (-(dataResult['costs-physical']+dataResult['costs-virtual'])) + (-dataResult['total-expenses'])) }}</strong></td>
                        <td class="grey lighten-2" v-if="filterAnalysis=='physical'"><strong>{{ roundToTwo(dataResult['sales-physical'] + (-dataResult['costs-physical']) + (-dataResult['total-expenses'])) }}</strong></td>
                        <td class="grey lighten-2" v-if="filterAnalysis=='virtual'"><strong>{{ roundToTwo(dataResult['sales-virtual'] + (-dataResult['costs-virtual']) + (-dataResult['total-expenses'])) }}</strong></td>
                    </tr>
                </tfoot>
                </template>
            </v-simple-table>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            itemsTimes: [
                {val: 'day', name: 'Día actual'},
                {val: 'week', name: 'Semana actual'},
                {val: 'month', name: 'Mes actual'},
                {val: 'year', name: 'Año actual'},
                {val: 'custom', name: 'Personalizado'},
            ],
            filterTime: 'month',
            itemsAnalysis:[
                {val: 'physical', name: 'Tienda física'},
                {val: 'virtual', name: 'Tienda virtual'},
                {val: 'both', name: 'Tienda virtual + fisica'},
            ],
            filterAnalysis: 'both',
            menu1: false,
            menu2: false,
            dateInit: '',
            dateEnd: '',
            // results
            dataResult: {}
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        async getData() {
            this.loading = true
            await axios.post('/admin/get-profits-results', {
                filterTime: this.filterTime,
                filterAnalysis: this.filterAnalysis,
                dateInit: this.dateInit,
                dateEnd: this.dateEnd
            })
            .then((response) => {
                // console.log(response);
                this.dataResult = response.data
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
            .finally(() => {
                this.loading = false
            })
        },
        roundToTwo(num) {
            return (+num).toFixed(this.numberDecimals);
        }
    },
    computed: {
        numberDecimals () {
            return this.$store.state.numberDecimals.numberDecimals
        }
    },
}
</script>
